import { useState, useEffect } from 'react';
import { BACKEND_URL } from '../config';
import fetchWithAuth from '../utils/fetchWithAuth';

const useTrips = () => {
  const [trips, setTrips] = useState([]);
  const [editingTrip, setEditingTrip] = useState(null);
  const [genericSavedMsg, setgenericSavedMsg] = useState("");
  const [refreshTrips, setRefreshTrips] = useState(false);

  useEffect(() => {
    fetchWithAuth(`${BACKEND_URL}/trips`)
      .then(res => res.json())
      .then(data => setTrips(data));
  }, [refreshTrips]);

  const addTrip = async (tripData) => {
    try {
      const response = await fetchWithAuth(`${BACKEND_URL}/trips`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(tripData)
      });
      const result = await response.json();
      if (!response.ok) {
        setgenericSavedMsg(result.error || "Error al guardar el viaje");
        return { error: result.error };
      }
      setgenericSavedMsg("Viaje guardado exitosamente.");
      setTimeout(() => setgenericSavedMsg(""), 3000);
      setRefreshTrips(r => !r);
      return {};
    } catch (err) {
      setgenericSavedMsg("Error al guardar el viaje");
      return { error: "Error al guardar el viaje" };
    }
  };

  const editTrip = async (tripData) => {
    try {
      const response = await fetchWithAuth(`${BACKEND_URL}/trips/${tripData.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(tripData)
      });
      const result = await response.json();
      if (!response.ok) {
        setgenericSavedMsg(result.error || "Error al editar el viaje");
        return { error: result.error };
      }
      setgenericSavedMsg("Viaje editado exitosamente.");
      setTimeout(() => setgenericSavedMsg(""), 3000);
      setEditingTrip(null);
      setRefreshTrips(r => !r);
      return {};
    } catch (err) {
      setgenericSavedMsg("Error al editar el viaje");
      return { error: "Error al editar el viaje" };
    }
  };

  const removeTrip = async (id) => {
    if (!window.confirm("¿Estás seguro de que quieres eliminar este viaje?")) return;
    try {
      const response = await fetchWithAuth(`${BACKEND_URL}/trips/${id}`, {
        method: 'DELETE'
      });
      if (!response.ok) throw new Error('Error al eliminar el viaje');
      setgenericSavedMsg("Viaje eliminado exitosamente.");
      setTimeout(() => setgenericSavedMsg(""), 3000);
      setRefreshTrips(r => !r);
    } catch (err) {
      setgenericSavedMsg("Error al eliminar el viaje");
    }
  };

  return {
    trips,
    addTrip,
    editTrip,
    removeTrip,
    editingTrip,
    setEditingTrip,
    genericSavedMsg,
    refreshTrips,
    setRefreshTrips
  };
};

export default useTrips;